import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PackageLinkComponent } from './package-link.component';
import { PipesModule } from "../pipes/pipes.module";
import { BookAppointmentModule } from '../book-appointment/book-appointment.module';

@NgModule({
  declarations: [PackageLinkComponent],
  imports: [
    CommonModule,
    PipesModule, BookAppointmentModule
],
exports: [PackageLinkComponent]
})
export class PackageLinkModule { }
